import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ExperiencesIndex from './Index.vue';
import ExperiencesForm from './Form.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/experiences'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'planning_experiences_index',
          meta: {
            permissions: ['administrator'],
          },
          component: ExperiencesIndex,
        },
        {
          path: 'new',
          name: 'planning_experiences_new',
          meta: {
            permissions: ['administrator'],
          },
          component: ExperiencesForm,
        },
        {
          path: ':experienceId/edit',
          name: 'planning_experiences_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: ExperiencesForm,
        },
      ],
    },
  ],
};
